import isWebComponentGame from "@casino/shared/utils/isWebComponentGame";
import { usePathname } from "next/navigation";
import { type FC, type ReactNode, useEffect, useMemo, useState } from "react";
import Toast from "..";
import ToastContext from "./ToastContext";

type Props = {
  userAgentData?: UserAgentData;
  children?: ReactNode;
  params?: Record<string, string>;
};

const initialState: ToastProps = {
  message: "",
  variant: "success",
  position: "bottom",
  timeout: 5000,
};

function canShowToast(webComponentGame: boolean, isMobile?: boolean): boolean {
  return !webComponentGame || isMobile === false;
}

const ToastContextProvider: FC<Props> = ({ children, userAgentData }) => {
  const [toastParams, setToastParams] = useState(initialState);
  const isMobile = userAgentData?.isMobile;

  const pathName = usePathname();
  const handle = pathName?.split("/").pop();

  const webComponentGame = isWebComponentGame(handle);

  useEffect(() => () => setToastParams(initialState), []);

  const handleOpenChange = (value: boolean) => {
    if (!value) {
      setToastParams(initialState);
    }
  };

  const values = useMemo(
    () => ({
      toastParams,
      setToastParams,
    }),
    [toastParams],
  );

  return (
    <ToastContext.Provider value={values}>
      {canShowToast(webComponentGame, isMobile) && (
        <Toast
          message={toastParams.message}
          isOpen={!!toastParams.message}
          onOpenChange={handleOpenChange}
          variant={toastParams.variant}
        />
      )}
      {children}
    </ToastContext.Provider>
  );
};

export default ToastContextProvider;
